import React from 'react';
import PropTypes from 'prop-types';
import PromptSuccess from './PromptSuccess';
import PromptFailure from './PromptFailure';
import PromptWarning from './PromptWarning';
import ClockPrompts from './ClockPrompts/ClockPrompts';
import GradientContainer from './CenteredContainer';
import { useWhiteLabelContext } from 'providers/WhiteLabelProvider';

const getPromptStyles = (theme, promptType) => {
  let gradientStart = theme.palette.background.paper;
  let gradientEnd = theme.palette.background.paper;
  let color = theme.palette.text.primary;

  switch (promptType) {
    case 'clockPrompts':
      gradientStart = theme.palette.info.dark;
      gradientEnd = theme.palette.info.light;
      color = theme.palette.common.white;
      break;
    case 'success':
      gradientStart = theme.palette.success.dark;
      gradientEnd = theme.palette.success.light;
      color = theme.palette.common.white;
      break;
    case 'warning':
      gradientStart = theme.palette.warning.main;
      gradientEnd = theme.palette.warning.light;
      color = theme.palette.common.white;
      break;
    case 'failure':
      gradientStart = theme.palette.error.main;
      gradientEnd = theme.palette.error.light;
      color = theme.palette.common.white;
      break;
    default:
      console.error('Invalid prompt type for getPromptStyles');
      break;
  }

  return {
    gradientStart,
    gradientEnd,
    color,
  };
};

export default function PromptContainer({
  clockPrompts,
  failure,
  success,
  warning,
}) {
  const { state: whiteLabelState } = useWhiteLabelContext();
  const { isEnclosedMode } = whiteLabelState || {};

  const promptTypes = [
    { type: 'failure', condition: failure },
    { type: 'success', condition: success },
    { type: 'warning', condition: warning },
    { type: 'clockPrompts', condition: clockPrompts },
  ];

  const activePromptType = promptTypes.find((prompt) => prompt.condition)?.type;
  const { gradientStart, gradientEnd, color } = getPromptStyles(
    require('@mui/material/styles').useTheme(),
    activePromptType
  );

  return (
    <GradientContainer
      id="prompt-container"
      gradientStart={gradientStart}
      gradientEnd={gradientEnd}
      gradientDirection="45deg"
      isEnclosedMode={isEnclosedMode}
      promptContainer
    >
      {failure && <PromptFailure />}
      {success && <PromptSuccess />}
      {warning && <PromptWarning />}
      {clockPrompts && <ClockPrompts />}
    </GradientContainer>
  );
}

PromptContainer.propTypes = {
  failure: PropTypes.bool,
  clockPrompts: PropTypes.bool,
  success: PropTypes.bool,
  warning: PropTypes.bool,
};
